import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { FiltroActividades } from 'src/app/shared/models/filtroActividades';
import { AsignacionesService } from 'src/app/core/services/asignaciones/asignaciones.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  spinner = true;
  listRegistros: any[] = [];
  page = 1;
  formDatos: FormGroup;
  total: number;
  totalResults: any[] = [];
  pages_total = 0;
  filtros = new FiltroActividades;
  filtrosCompletados = false;
  from = 0;
  to = 100;
  constructor(private form: FormBuilder,
    private router: Router,
    private asignacionesService: AsignacionesService,
    private _snackBar: MatSnackBar,) {

    $('#spinner-load').css("display", "block");

    let filtros = localStorage.getItem('ET_EMYRfiltroActividadesHome')
    if (!filtros) {
      this.filtros = new FiltroActividades();
    } else {
      this.filtros = JSON.parse(filtros);

    }

    this.from = this.filtros.min;
    this.to = this.filtros.max;
    this.formDatos = this.form.group({
      numberOT: [this.filtros.numberOT],
      dateFrom: [this.filtros.dateFrom],
      dateUntil: [this.filtros.dateUntil],
      activity: [this.filtros.activity],
      state: [this.filtros.state],
      code: [this.filtros.code],
      name: [this.filtros.name],
      section: [this.filtros.section],

    });
    this.cargarLista()
  }



  ngOnInit(): void {

  }

  ngAfterViewInit() {


    $('.ui.dropdown').dropdown({
      "clearable": true
    });

    $('.ui.selection.dropdown').dropdown({
      "clearable": true
    });
  }
  otFilters: any = [];
  activityFilters: any = [];
  utFilters: any = [];
  stateFilters: any = [];
  sectionFilters: any = [];
  nameFilters: any = [];
  codeFilters: any = [];
  cargarLista() {
    $('#spinner-load').css("display", "block");

    this.asignacionesService.getAllResults(this.page, 12, this.filtros).subscribe(res => {
      this.listRegistros = res.data;
      this.pages_total = res.totalPages;
      this.page = res.pageNumber;
      this.otFilters = res.otList;
      this.stateFilters = res.stateUtList;
      this.sectionFilters = res.sectionList;
      this.nameFilters = res.nameList;
      this.codeFilters = res.codeList;
      this.activityFilters = res.activityList;
      this.spinner = false;
      $('#spinner-load').css("display", "none");
    },
      error => {
        this._snackBar.open('Ocurrio un error al cargar los datos', 'x', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center',
          panelClass: ['error-snackbar'],
        });
        $('#spinner-load').css("display", "none");

      })

  }

  completarFiltros() {

    this.filtrosCompletados = true;

  }


  detalle(item) {
    this.router.navigate(["detalle/" + ((item.Activity_Dsc == 'Evaluación completa') ? 'evaluacion-completa' : item.Activity_Dsc )+ "/" + item.Mission_Id]);
  }



  limpiar() {
    this.page = 1;
    this.filtros = null;
    this.formDatos.controls['numberOT'].setValue(null)
    this.formDatos.controls['dateFrom'].setValue(null)
    this.formDatos.controls['dateUntil'].setValue(null)
    this.formDatos.controls['activity'].setValue(null)
    this.formDatos.controls['state'].setValue(null)
    this.formDatos.controls['section'].setValue(null)
    this.formDatos.controls['name'].setValue(null)
    this.formDatos.controls['code'].setValue(null)
    this.to = 100;
    this.from = 0;
    this.filtros = new FiltroActividades();
    localStorage.setItem('ET_EMYRfiltroActividadesHome', JSON.stringify(this.filtros))
    $('.ui.dropdown').dropdown('restore defaults');

    this.cargarLista()
  }

  changePage(number_page: number) {
    this.page = number_page;
    this.cargarLista();
  }

  aplicar() {
    this.page = 1;
    this.filtros = new FiltroActividades();
    this.filtros.numberOT = this.formDatos.get('numberOT').value;
    this.filtros.dateFrom = this.formDatos.get('dateFrom').value;
    this.filtros.dateUntil = this.formDatos.get('dateUntil').value;
    this.filtros.activity = this.formDatos.get('activity').value;
    this.filtros.state = this.formDatos.get('state').value;
    this.filtros.code = this.formDatos.get('code').value;
    this.filtros.name = this.formDatos.get('name').value;
    this.filtros.section = this.formDatos.get('section').value;
    this.filtros.max = this.to
    this.filtros.min = this.from

    localStorage.setItem('ET_EMYRfiltroActividadesHome', JSON.stringify(this.filtros))

    $('#spinner-load').css("display", "block");

    this.cargarLista()


  }
  setForm(event) {
    this.formDatos.controls[event.name].setValue(event.value)
  }


  onChangeEvent(event) {
    if (event.to != undefined) {
      this.to = event.to
    }
    if (event.from != undefined) {
      this.from = event.from
    }
  }

  isDescending(field: string): boolean {
    const crit = this.filtros.sortCriteriaList.find(c => c.field === field);
    return !crit || !crit.ascending; // por defecto descendente
  }

  changeOrder(field: string): void {
    const list = this.filtros.sortCriteriaList;
    const index = list.findIndex(c => c.field === field);

    if (index >= 0) {
      // Invertir el orden
      list[index].ascending = !list[index].ascending;

      // Moverlo al principio (opcional si querés que tenga más prioridad)
      const updated = list.splice(index, 1)[0];
      list.unshift(updated);
    } else {
      // Si no existía, lo agregamos
      list.unshift({ field, ascending: false });
    }
    this.page = 1;
    this.cargarLista();
  }
}
